import React, { useState, useEffect } from "react";
import api from "services/api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import Translator, { __ } from "services/Translator";

const HomeBannerSingle = (props) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const [homeBanners, setHomeBanners] = useState([]);
  const getHomeBanners = async () => {
    var response = await api.get("/banners");
    if (response.status === 200) {
      setHomeBanners(response.data);
    }
  };

  useEffect(() => {
    getHomeBanners();
  }, []);

  return (
    <>
      <section className="home_banner_area">
        <Slider {...settings}>
          <div className="slide-item">
            <div className="single-banner">
              <div className="banner-content">
                <div className="pre-heading-text">
                  Become part of the Winnabull family
                </div>
                <div className="heading">America's #1 Social Casino</div>
                <div className="sub-heading">
                  Step into the world of free and safe gaming with Winnabull,
                  the social casino for enthusiasts in the USA.
                </div>
                <Link className="commonBtn pushableBtn bannerBtn">
                  <span className="front">
                    Play Now{" "}
                    <svg
                      width="7"
                      height="13"
                      viewBox="0 0 7 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L1 11.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
                {/* <div className="banner-counter">
                  <div className="counter-item">
                    <b>1,000+</b> Casino Games
                  </div>
                  <div className="counter-item">
                    <b>15+</b> Best Game Providers
                  </div>
                </div> */}
              </div>
              {props.isMobileDevice ? (
                <img
                  src={require("assets/winnabull/images/banners/mobile-banner-one.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              ) : (
                <img
                  src={require("assets/winnabull/images/banners/banner-one.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              )}
            </div>
          </div>
          <div className="slide-item">
            <div className="single-banner">
              <div className="banner-content">
                <div className="pre-heading-text">
                  Become part of the Winnabull family
                </div>
                <div className="heading">Maximum Promotions</div>
                <div className="sub-heading">
                  Unlock the best social casino deals with Winnabull. Our casino
                  ensures a thrilling experience with real prize opportunities.
                </div>
                <Link className="commonBtn pushableBtn bannerBtn">
                  <span className="front">
                    Play Now{" "}
                    <svg
                      width="7"
                      height="13"
                      viewBox="0 0 7 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L1 11.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
                <div className="banner-counter">
                  <div className="counter-item">
                    Weekly Tournaments (Races) with BIG prizes
                  </div>
                  <div className="counter-item">Daily Bonuses and Perks</div>
                </div>
              </div>

              {props.isMobileDevice ? (
                <img
                  src={require("assets/winnabull/images/banners/mobile-banner-two.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              ) : (
                <img
                  src={require("assets/winnabull/images/banners/banner-two.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              )}
            </div>
          </div>
          <div className="slide-item">
            <div className="single-banner">
              <div className="banner-content">
                <div className="pre-heading-text">
                  Become part of the Winnabull family
                </div>
                <div className="heading">
                  Level Up <br /> Rewards
                </div>
                <div className="sub-heading">
                  Boost your gameplay with Winnabull's tiered loyalty system!
                  Unlock exclusive bonuses, faster Rakeback plus special perks
                  as you climb the levels.
                </div>
                <Link className="commonBtn pushableBtn bannerBtn">
                  <span className="front">
                    Play Now{" "}
                    <svg
                      width="7"
                      height="13"
                      viewBox="0 0 7 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L1 11.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </Link>
                <div className="banner-counter">
                  <div className="counter-item">
                    <b>16</b> Levels to Achieve
                  </div>
                  <div className="counter-item">
                    <b>100+</b> Rewards to Unlock
                  </div>
                </div>
              </div>
              {props.isMobileDevice ? (
                <img
                  src={require("assets/winnabull/images/banners/mobile-banner-three.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              ) : (
                <img
                  src={require("assets/winnabull/images/banners/banner-three.png")}
                  alt="Winnabull Casino "
                  className="bigBanner"
                />
              )}
            </div>
          </div>
        </Slider>
      </section>
    </>
  );
};

export default HomeBannerSingle;
